export class AchAccount {
  id: number;
  achAccountGuid: string;
  profileId: number;
  accountNickname: string;
  achCustomerId: number;
  isTermsAuthFlag: boolean;
  termsAuthDate: Date;
  accountNumberLast4Digits: number;
  paymentAccountTypeId: number;
  accountVerifyStatusTypeId: number;
  accountVerifyAchTranId: number;
  name: string;
  company: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  phone: string;
  email: string;
  nsfCount: number;
  isDeletedFlag: boolean;
}
